// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cancelBtn___73e5U{height:16px;width:48px}.addToGroupBtn___jphMc{height:32px}\n", "",{"version":3,"sources":["webpack://./src/routes/ManageTenants/routes/TenantGroup/routes/AddTenant/components/AddTenantPageHeader/AddTenantPageHeader.css"],"names":[],"mappings":"AAAA,mBACI,WAAA,CACA,UAAA,CAGJ,uBACI,WAAA","sourcesContent":[".cancelBtn {\n    height: 16px;\n    width: 48px;\n}\n\n.addToGroupBtn {\n    height: 32px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cancelBtn": "cancelBtn___73e5U",
	"addToGroupBtn": "addToGroupBtn___jphMc"
};
export default ___CSS_LOADER_EXPORT___;
